// Copyright (c) 2020 WiseTime. All rights reserved.

import { combineEpics } from "redux-observable"
import persistToolbarFilters from "./persistToolbarFilters"
import loadToolbarFilters from "./loadToolbarFilters"
import countFilteredTimeRowsByDay from "./countFilteredTimeRowsByDay"
import createTimelineMarker from "./createTimelineMarker"

export default combineEpics(
  persistToolbarFilters,
  loadToolbarFilters,
  countFilteredTimeRowsByDay,
  createTimelineMarker,
)
